var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 65,
    viewBox: "0 0 75 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(0 28.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M64.014,235.588H56.672a10.482,10.482,0,0,0-2.887.406,10.954,10.954,0,0,0-9.8-6.314H31.011a10.954,10.954,0,0,0-9.8,6.314,10.482,10.482,0,0,0-2.887-.406H10.986A11.274,11.274,0,0,0,0,247.106v12.3a6.765,6.765,0,0,0,6.592,6.911H68.408A6.765,6.765,0,0,0,75,259.409v-12.3A11.274,11.274,0,0,0,64.014,235.588ZM20.025,241.2v20.515H6.592a2.255,2.255,0,0,1-2.2-2.3v-12.3a6.765,6.765,0,0,1,6.592-6.911h7.342a6.286,6.286,0,0,1,1.724.241C20.036,240.689,20.025,240.942,20.025,241.2ZM50.58,261.713H24.42V241.2a6.765,6.765,0,0,1,6.592-6.911H43.989A6.765,6.765,0,0,1,50.58,241.2Zm20.025-2.3a2.255,2.255,0,0,1-2.2,2.3H54.975V241.2c0-.256-.011-.509-.027-.761a6.292,6.292,0,0,1,1.724-.241h7.342a6.765,6.765,0,0,1,6.592,6.911Z",
    transform: "translate(0 -229.68)",
    fill: "#2e3d62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(5.131 12.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M43.649,126.5a10.235,10.235,0,1,0,10.235,10.235A10.246,10.246,0,0,0,43.649,126.5Zm0,15.862a5.628,5.628,0,1,1,5.628-5.628A5.634,5.634,0,0,1,43.649,142.366Z",
    transform: "translate(-33.414 -126.504)",
    fill: "#2e3d62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(23.827 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M180.635,43.729A13.673,13.673,0,1,0,194.309,57.4,13.689,13.689,0,0,0,180.635,43.729Zm0,22.74A9.066,9.066,0,1,1,189.7,57.4,9.077,9.077,0,0,1,180.635,66.469Z",
    transform: "translate(-166.962 -43.729)",
    fill: "#2e3d62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(49.399 12.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M355.529,126.5a10.235,10.235,0,1,0,10.235,10.235A10.246,10.246,0,0,0,355.529,126.5Zm0,15.862a5.628,5.628,0,1,1,5.628-5.628A5.634,5.634,0,0,1,355.529,142.366Z",
    transform: "translate(-345.294 -126.504)",
    fill: "#2e3d62"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT3);
export default __webpack_public_path__ + "static/media/T3.e8d746b052c9f06415235c5d82d179f6.svg";
export { ForwardRef as ReactComponent };